import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ShowSelectToggleIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M22 5C22.5523 5 23 4.5523 23 4V2C23 1.4477 22.5523 1 22 1H20C19.4477 1 19 1.4477 19 2V3.75H14V2C14 1.4477 13.5523 1 13 1H11C10.4477 1 10 1.4477 10 2V3.75H5V2C5 1.4477 4.5523 1 4 1H2C1.4477 1 1 1.4477 1 2V4C1 4.5523 1.4477 5 2 5H3.75V10H2C1.4477 10 1 10.4477 1 11V13C1 13.5523 1.4477 14 2 14H3.75V19H2C1.4477 19 1 19.4477 1 20V22C1 22.5523 1.4477 23 2 23H4C4.5523 23 5 22.5523 5 22V20.25H10V22C10 22.5523 10.4477 23 11 23H13C13.5523 23 14 22.5523 14 22V20.25H19V22C19 22.5523 19.4477 23 20 23H22C22.5523 23 23 22.5523 23 22V20C23 19.4477 22.5523 19 22 19H20.25V14H22C22.5523 14 23 13.5523 23 13V11C23 10.4477 22.5523 10 22 10H20.25V5H22ZM18.75 18.75H5.25V5.25H18.75V18.75Z"
        fill={color}
      />
      <path
        d="M13 10H11C10.4477 10 10 10.4477 10 11V13C10 13.5523 10.4477 14 11 14H13C13.5523 14 14 13.5523 14 13V11C14 10.4477 13.5523 10 13 10Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ShowSelectToggleIcon.displayName = 'ShowSelectToggleIcon';
